<template>
    <div class="billing-address-modal" v-if="isRender && showModal">
        <CModal
            :show="showModal"
            :backdrop="false"
            @update:show="hideCheckout"
        >
            <template v-slot:header-wrapper>
                <div></div>
            </template>

            <CButtonClose @click="hideCheckout($event)"/>

            <div class="billing-wrapper">
                <div class="billing-sections billing-notes">
                    <div class="modal-title mb-4"><strong>{{texts.billingTitle ? texts.billingTitle : ''}}</strong></div>
                    <p>{{texts.billingNotes ? texts.billingNotes : ''}}</p>
                </div>
                <div class="billing-sections billing-form">
                    <div class="billing-form__fields">
                        <div class="modal-title mb-4"><strong>Billing Address (Optional)</strong></div>
                        <div>
                            <CInput
                                label="Full Name"
                                placeholder="Enter your full name"
                                v-model="inputData.address.firstLine"
                            />
                        </div>
                        <div>
                            <CInput
                                label="Address Line 1"
                                placeholder="Enter your address line 1"
                                v-model="inputData.address.region"
                            />
                        </div>
                        <div>
                            <CInput
                                label="City"
                                placeholder="Enter your city"
                                v-model="inputData.address.city"
                            />
                        </div>
                    </div>
                    <div class="billing-form__submit">
                        <button type="button" :class="btnClasses + ' continue-button'" @click="clickContinue">
                            Continue
                        </button>
                    </div>
                </div>
            </div>

            <template v-slot:footer>
                <div class="m-0"></div>
            </template>
        </CModal>
    </div>
</template>

<script>
import {
    registerEventCallback,
    updateCheckout,
    closeCheckout
} from '@/scripts/paddle'
import gql from "graphql-tag";
import {apolloClient} from "@/plugins/apollo";

export default {
    data() {
        return {
            showModal: false,
            billingAddress: null,
            texts: {},
            inputData: {
                customer: {
                    name: '',
                },
                address: {
                    city: '',
                    firstLine: '',
                    region: ''
                }
            },
        }
    },
    methods: {
        hideCheckout() {
            closeCheckout();
            this.showModal = false
        },
        clickContinue() {
            this.showModal = false;
            this.saveBilling();
            this.billingAddress = {};
        },
        hideIframe(shouldHide = true) {
            let iframe = document.querySelector('.paddle-frame-overlay');
            if (iframe) {
                iframe.style.display = shouldHide ? "none" : "";
            }
        },
        showUpdateBillingAddress(data) {
            if (typeof data === 'object') {
                this.billingAddress = data;
                this.showModal = true;
            }
        },
        saveBilling() {
            let address = {...this.billingAddress.customer.address, ...this.inputData.address};
            delete address.id;
            console.log('address', {
                customer: {
                    id: this.billingAddress.customer.id,
                    address: address
                }
            });
            updateCheckout({
                customer: {
                    id: this.billingAddress.customer.id,
                    address: address
                }
            });
        },
        async loadTexts() {
            let query = gql`{ settings { billingNotes billingTitle } }`
            let qRes = await apolloClient.query({query})
            this.texts = qRes.data['settings'];
        }
    },
    computed: {
        btnClasses() {
            return [`btn btn-info`]
        },
        isRender() {
            return typeof this.billingAddress === 'object';
        }
    },
    watch: {
        showModal(showValue) {
            this.hideIframe(showValue)
        }
    },
    created() {
        this.hideIframe(true)
        registerEventCallback('checkout.customer.updated', this.showUpdateBillingAddress)
        this.loadTexts();
    },
    destroyed() {
        this.hideIframe(false)
    }
}
</script>

<style lang="scss">
.billing-address-modal {
    font-size: 15px;

    .overflow-auto {
        background: rgba(48, 47, 60, 0.8);
        display: flex !important;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .modal-dialog {
        min-width: 780px;
    }

    .modal-content {
        border-radius: 0.8rem;
        height: 520px;
    }

    .modal-header {
        border-bottom: 0;
        display: block;
    }

    .modal-body {
        padding: 0;
        .close {
            position: absolute;
            right: 18px;
            top: 12px;
        }
    }

    .modal-footer {
        border-top: 0;
        display: block;
        padding: 0;
    }

    .billing-wrapper {
        display: flex;
        height: 100%;
    }
    .billing-sections {
        border-radius: 0.8rem;
        height: 100%;
        padding: 1.2rem;
        width: 50%;
    }

    .billing-form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .billing-notes {
        background-color: rgb(249, 249, 249);
    }

    .btn {
        font-size: 17px;
        font-weight: 600;
    }
    .continue-button {
        width: 100%;
    }

    .form-group {
        label {
            margin-bottom: 0;
        }
    }

    @media screen and (max-width: 815px) {
        .overflow-auto {
            display: block !important;
        }
        .modal-dialog {
            margin: 0;
            max-width: 100%;
            min-width: 0;
            height: 100%;
        }
        .modal-content {
            border-radius: 0;
            height: 100%;
        }
        .billing-wrapper {
            align-items: center;
            flex-direction: column;
            row-gap: 2rem;
        }
        .billing-sections {
            height: auto;
            max-width: 630px;
            width: 100%;
        }
        .billing-form__fields {
            margin-bottom: 30px;
        }
        .billing-notes {
            border-radius: 0;
            width: 100%;
        }
    }
}
</style>